export default {
  pufa: {
    home: 'https://kmt.laway.cn/pufa/km/home/',
    list: 'https://hnxcja.12348.laway.cn/postnews/list/?video=1',
    post: 'https://hnxcja.12348.laway.cn/postnews/view/?post_id='
  },
  list: '/pufa/api/post/list/?per_page=500&diagram_id=',
  post: '/pufa/post/?post_id=',
  // map: '/pufa/api/org/list/?per_page=500&org_type=',
  map: '/pufa/api/organization/?org_type=',
  xiaoxiang: {
    list: 'https://xiaoxiangs.laway.cn/question/list/',
    answer: 'https://xiaoxiangs.laway.cn/question/answer/'
  },
  case: 'https://hnxcja.12348.laway.cn/pufa/case/list/',
  case_post: 'https://hnxcja.12348.laway.cn/pufa/case/aview/?case_id=',
  lawfirm: 'https://hnxcja.12348.laway.cn/pufa/api/publiclawfirm/?code=',
  employee: 'https://hnxcja.12348.laway.cn/pufa/api/publiclawyer/?lawfirm=',
  jiandingoffice: 'https://hnxcja.12348.laway.cn/pufa/api/organization/?org_type=1&code=',
  jiandingemployee: 'https://hnxcja.12348.laway.cn/pufa/api/organizationemployee/?org_id=',
  heartbeat: 'https://hnxcja.12348.laway.cn/pufa/app/heartbeat/',
  caselibrary: 'https://hnxcja.12348.laway.cn/case/libary/',
  caselibrary_post: 'https://hnxcja.12348.laway.cn/case/libary/view/',

  hrpay: 'https://hrpay.laway.cn/api/speed-front', // 案例库查询
  doc: {
    types: 'https://hrpay.laway.cn/api/speed-front/doc/categories',
    list: `https://hrpay.laway.cn/api/speed-front/doc/list`, // 分类下列表
    detail: `https://hrpay.laway.cn/api/speed-front/doc/detail?userId=yichanguser&htmlContent=&id=`, // 详情
    hotlist: `https://hrpay.laway.cn/api/speed-front/doc/hotDocs` // 热门文档列表
  }
}



// WEBPACK FOOTER //
// ./src/datas/api.js